import VendorLink from '../Util/VendorLink';

export default function Footer(props) {
  return(
    <footer className="app__footer">
      <VendorLink />
    </footer>
  );
}
